export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0A1628] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-12 md:mb-16">
          {/* Company Info */}
          <div className="md:col-span-12 lg:col-span-4">
            <img 
              src="https://static.readdy.ai/image/6b6b6fa7c6c47b49bd5802c74709554d/b8dabc6cce1111c1baf649ac8ec32ef9.png" 
              alt="Superior Equipment and Technology" 
              className="h-8 md:h-10 w-auto object-contain mb-4 md:mb-6 brightness-0 invert"
            />
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs mb-6 md:mb-8">
              Leading provider of advanced industrial equipment and innovative technology solutions, empowering businesses to achieve operational excellence.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-gray-600 flex items-center justify-center hover:border-[#0066FF] hover:bg-[#0066FF]/10 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-gray-600 flex items-center justify-center hover:border-[#0066FF] hover:bg-[#0066FF]/10 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-gray-600 flex items-center justify-center hover:border-[#0066FF] hover:bg-[#0066FF]/10 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-6 lg:col-span-3">
            <h3 className="text-base font-semibold mb-4 md:mb-6">Quick Links</h3>
            <ul className="space-y-3 md:space-y-4">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="text-sm text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-sm text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Solutions
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('overview')}
                  className="text-sm text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer whitespace-nowrap"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm text-gray-400 hover:text-[#0066FF] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="md:col-span-6 lg:col-span-5">
            <h3 className="text-base font-semibold mb-4 md:mb-6">Get In Touch</h3>
            <div className="space-y-4 md:space-y-5">
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-xl text-[#0066FF]"></i>
                </div>
                <div>
                  <a href="tel:+18084217414" className="text-sm text-gray-400 hover:text-[#0066FF] transition-colors whitespace-nowrap">
                    +1 (808) 421-7414
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-xl text-[#0066FF]"></i>
                </div>
                <div>
                  <a href="https://support@superiorethi.com" className="text-sm text-gray-400 hover:text-[#0066FF] transition-colors break-all">
                    support@superiorethi.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-xl text-[#0066FF]"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-400 leading-relaxed">
                    1633 Kahai St.<br />
                    Honolulu, HI 96819, USA
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="pt-6 md:pt-8 border-t border-[#1A2332]">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs md:text-sm text-gray-500 text-center md:text-left">
              © 2024 Superior Equipment & Technology. All rights reserved.
            </p>
            <div className="flex items-center gap-4 md:gap-6 flex-wrap justify-center">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm text-gray-500 hover:text-[#0066FF] transition-colors cursor-pointer whitespace-nowrap">
                Website Builder
              </a>
              <span className="text-gray-600">|</span>
              <button className="text-xs md:text-sm text-gray-500 hover:text-[#0066FF] transition-colors cursor-pointer whitespace-nowrap">
                Privacy Policy
              </button>
              <span className="text-gray-600">|</span>
              <button className="text-xs md:text-sm text-gray-500 hover:text-[#0066FF] transition-colors cursor-pointer whitespace-nowrap">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
